/**
 * Check for recommendation categories in categories list
 * @param category
 */
function dynamicRecommendationCategories(category) {
    if (category.greSettings !== undefined) {
        return true;
    }
    if (category.subCategories && Array.isArray(category.subCategories)) {
        return category.subCategories.some(function (sub) {
            return dynamicRecommendationCategories(sub);
        });
    }
    return false;
}

export { dynamicRecommendationCategories };
